import { isType, DynamicCampaignReceivedAction } from './../actions/actions';
import { initialDynamicCampaignState, copyState } from './../../State';
export default function campaignReducer(state = initialDynamicCampaignState, action) {
    let newState = copyState(state);
    if (isType(action, DynamicCampaignReceivedAction)) {
        newState = action.payload.campaignInfo;
    } else {
        return state;
    }
    return newState;
}
